import styled from 'styled-components';

import { useAuthUser, useTenant } from 'hooks';
import { getBase64 } from 'utils/prepareFormData';

export const useBDOLoyaltyEnabled = () => {
  const tenant = useTenant();

  const isBDOClient = ['bdo', 'bdo_rewards_uat', 'bdo_preprod'].includes(tenant?.name);

  return isBDOClient;
};

export const ActionsBtnGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  flex-direction: row;
  justify-content: flex-end;
`;

export const formItemLayout = {
  labelAlign: 'right',
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
} as const;

export const SectionHeader = styled.h1`
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
`;

export const useBDOPermissions = () => {
  const authUser = useAuthUser();
  const roles = authUser?.roles || [];

  const approverRoles = [
    'Checker',
    'Approver',
    'Bulk action - Checker',
    'Super Admin',
    'tenant admin',
    'Tenant Admin'
  ];
  const makerRoles = [
    'Maker 1',
    'Maker 2',
    'Maker, Bulk action - Maker',
    'Super Admin',
    'tenant admin',
    'Tenant Admin'
  ];
  const cardActionRole = [
    'Bulk action - Maker',
    'Bulk action - Checker',
    'Maker 1',
    'Maker 2',
    'Approver',
    'Super Admin',
    'tenant admin',
    'Tenant Admin'
  ];

  const canApproveRequest = roles.some(role => approverRoles.includes(role.name));
  const canCreateRequest = roles.some(role => makerRoles.includes(role.name));
  const canPerformCardActions = roles.some(role => cardActionRole.includes(role.name));

  return { canApproveRequest, canCreateRequest, canPerformCardActions };
};

export const checkPayloadForFile = async (body: any, fieldName: string = 'logo') => {
  if (body?.image?.file && body.image.file instanceof File) {
    const base64Image = await getBase64(body.image.file);
    const images = [
      {
        file: base64Image,
        filename: body.image.file.name
      }
    ];
    delete body.image;
    return { ...body, images };
  }
  return body;
};

export const getCardTypeByName = cardType => {
  switch (cardType) {
    case 'airmile':
      return 'Airmile';
    case 'hotel_loyalty':
      return 'Hotel Loyalty';
    case 'membership_fee':
      return 'Membership Fee';
    case 'paper':
      return 'Voucher';
    case 'evoucher':
      return 'Voucher';
    case 'cash_credit':
      return 'Cash Credit';
    default:
      return cardType || '';
  }
};
export async function convertUrlToFile(url) {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    return null;
  }
}
